import React from 'react';
import { Link } from 'react-router-dom';
import { Stars, Heart } from 'lucide-react';
import { NUMEROLOGY_URL } from "../config";

export const Hero = () => {
  return (
    <section
      className="hero-section relative bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1561148493-89acae53e6a1')`
      }}
    >
      {/* Overlay lembut TANPA blur supaya background tetap jelas */}
      <div className="absolute inset-0 bg-gradient-to-t from-white/12 via-white/2 to-transparent" />

      <div className="hero-content relative z-10 text-center px-4 py-24">
        <div className="hero-announcement flex justify-center items-center gap-2 mb-4 text-sm font-medium text-gray-700">
          <Stars className="h-4 w-4 text-amber-600" />
          <span className="tracking-wide">PANDUAN SPIRITUAL MODERN</span>
        </div>

        <h1 className="heading-hero mb-6 text-4xl sm:text-5xl font-bold text-gray-900 drop-shadow-[0_2px_6px_rgba(255,255,255,0.9)]">
          Kenali dan Rangkullah Dirimu<br />
          Bersama Desy Clare
        </h1>

        <p className="body-large mb-8 max-w-2xl mx-auto text-gray-800 leading-relaxed bg-white/75 px-4 py-2 rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
          Temukan dan sadari potensi, kekuatan, sisi gelap dan arah hidupmu melalui ilmu numerologi dan spiritual modern.
          Pahami karaktermu yang unik dan raih kehidupan yang seimbang dengan penuh makna.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href={NUMEROLOGY_URL} className="btn-primary">
            COBA SEKARANG
          </a>
          {/*<Link to="/about" className="btn-secondary">
            Pelajari Lebih Lanjut
          </Link>*/}
        </div>

        <div className="flex items-center justify-center gap-2 mt-10 text-gray-700 bg-white/75 px-3 py-1.5 rounded-full shadow-[0_2px_8px_rgba(0,0,0,0.1)]">
          <Heart className="h-4 w-4 text-rose-400" />
          <span className="caption font-medium">
            Temukan potensi sejati dirimu melalui numerologi modern.
          </span>
          <Heart className="h-4 w-4 text-rose-400" />
        </div>
      </div>
    </section>
  );
};
